import { Badge, HStack } from '@chakra-ui/react'
import type { ChildTicketTask } from '@/lib/services/childTicketService'
import { taskPanelBadgeLabels } from './taskUtils'

type Props = {
  task: ChildTicketTask
}

function badgeColorScheme(label: string): string {
  if (label === 'Assets') return 'purple'
  if (label.includes('Store') || label === 'Store') return 'orange'
  if (label === 'Parts') return 'cyan'
  if (label === 'Permit') return 'gray'
  if (label === 'Embed' || label === 'External' || label === 'Custom') return 'teal'
  return 'blue'
}

export default function TaskPanelBadge({ task }: Props) {
  const labels = taskPanelBadgeLabels(task)
  if (labels.length === 0) return null

  return (
    <HStack spacing={1}>
      {labels.map((label) => (
        <Badge key={label} colorScheme={badgeColorScheme(label)} fontSize="2xs" borderRadius="sm" textTransform="none">
          {label}
        </Badge>
      ))}
    </HStack>
  )
}
